import React from 'react';
import { useLang } from '../../context/LanguageContext';
import { Globe } from 'lucide-react';

/**
 * Elegant FR | EN toggle used in the top utility bar.
 * Keyboard-accessible, no layout shift, matches Selora palette.
 */
export default function LanguageToggle({ className = '', variant = 'dark' }) {
  const { lang, toggleLang } = useLang();
  const isEn = lang === 'en';

  const isLight = variant === 'light';
  const base = isLight
    ? 'border-[#E8E4DC] hover:border-[#D4AF37] bg-white hover:bg-[#FAF7F0] text-[#1A2F4A]'
    : 'border-white/25 hover:border-[#D4AF37]/70 bg-white/5 hover:bg-[#D4AF37]/10 text-white';
  const dividerColor = isLight ? 'text-[#1A2F4A]/30' : 'text-white/40';
  const inactive = isLight ? 'text-[#1A2F4A]/60' : 'text-white/70 group-hover:text-white';

  return (
    <button
      type="button"
      onClick={toggleLang}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleLang(); } }}
      aria-label={isEn ? 'Switch language to French' : 'Passer la langue à l\'anglais'}
      aria-pressed={isEn}
      title={isEn ? 'Switch to French' : 'Passer en anglais'}
      data-testid="language-toggle"
      className={`group inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[11px] font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-[#D4AF37]/60 ${base} ${className}`}>
      <Globe className="w-3 h-3 text-[#D4AF37]" aria-hidden="true" />
      <span
        className={`transition-colors ${!isEn ? 'text-[#D4AF37]' : inactive}`}
        data-testid="lang-fr">FR</span>
      <span className={dividerColor} aria-hidden="true">|</span>
      <span
        className={`transition-colors ${isEn ? 'text-[#D4AF37]' : inactive}`}
        data-testid="lang-en">EN</span>
    </button>
  );
}
